import React from 'react'
import Navbar from '../../components/Public/Navbar'
import Footer from '../../components/Public/Footer'
import Main from './ContactUs/Main'

export default function ContactUs() {
  return (
    <>
      <Navbar />
      <Main />
      <Footer />
    </>
  )
}
